import React, { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Box, Spinner } from '@chakra-ui/react';

import { useApi, useEntityState } from '@app/hooks';

import { StandFormInstance } from './types';
import StandForm from './form';
import { Paper } from '../common';

const StandEdit: FC = () => {
  const params = useParams<{ id: string }>();
  const api = useApi();

  const history = useHistory();

  const [instance, onChange, setInstance] = useEntityState<StandFormInstance>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!params.id) {
      return;
    }

    (async () => {
      setLoading(true);
      const { data: stands } = await api.stands.getStands({
        filter: { id: params.id },
        sort: '+id',
        offset: 0,
        limit: 1
      });
      
      if (stands.data.length) {
        setInstance(stands.data[0]);
      }
      setLoading(false);
    })();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);


  const onFormSubmit = async () => {
    setLoading(true);
    const response = await api.stands
      .updateStand({
        id: instance.id?.toString() || '',
        model_id: instance.model?.id?.toString() || '',
      });


      setLoading(false);
      history.push('/equipments-stands/');
  };

  const onFormCancel = () => {
    history.push('/equipments-stands/');
  };

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={4} paddingY={6}>
          {!instance && loading ? (
            <Box
              width="100%"
              height="300px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Spinner />
            </Box>
          ) : (
            <StandForm
              instance={instance}
              onChange={onChange}
              onSubmit={onFormSubmit}
              onCancel={onFormCancel}
              submitText="Изменить"
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default StandEdit;
